import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Shell from '../Shell';
import { api } from '../api';
import { useToast } from '../ToastContext';
import { useAuth } from '../AuthContext';

export default function Welcome() {
  const [busy, setBusy] = useState(false);
  const toast = useToast();
  const nav = useNavigate();
  const { user } = useAuth();

  async function seed() {
    setBusy(true);
    try {
      await api.seedDemo();
      toast.push('Demo data loaded');
      nav('/mailbox');
    } catch (e) {
      toast.push(e.message, { variant: 'error' });
    } finally { setBusy(false); }
  }

  return (
    <Shell title={`Welcome, ${user?.name || 'there'}`} subtitle="Let's set up your workspace in 30 seconds.">
      <div className="welcome-grid">
        <div className="card welcome-card">
          <div className="welcome-icon">🚀</div>
          <h2 className="card-title">Option A — Start with demo data</h2>
          <p>Load a sample tenant: 3 customers (Boeing, Airbus, Embraer), 5 suppliers, and one inbound email waiting in your mailbox. Best way to feel the workflow.</p>
          <button className="btn" onClick={seed} disabled={busy}>{busy ? 'Seeding…' : 'Load demo data'}</button>
        </div>
        <div className="card welcome-card">
          <div className="welcome-icon">✏️</div>
          <h2 className="card-title">Option B — Set up yourself</h2>
          <p>Add your own customers, suppliers, and kick off your first RFQ from scratch. If you already have an Excel template with line items, you can upload it.</p>
          <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
            <button className="btn btn-secondary" onClick={() => nav('/customers')}>Add a customer</button>
            <button className="btn btn-secondary" onClick={() => nav('/suppliers')}>Add a supplier</button>
            <button className="btn" onClick={() => nav('/inbox')}>+ New RFQ</button>
          </div>
        </div>
      </div>

      <div className="card" style={{ marginTop: 24 }}>
        <h3 className="card-title">What Rivet does</h3>
        <ol style={{ paddingLeft: 20, lineHeight: 1.7 }}>
          <li><b>Mailbox</b> — inbound customer emails land here; one click converts them into structured RFQs.</li>
          <li><b>Dispatch</b> — pick suppliers; Rivet records who you contacted and when.</li>
          <li><b>Capture</b> — enter supplier quotes; quality status (QPL, CoC, condition, alternate) derives live.</li>
          <li><b>Compare</b> — 3-layer matrix: RFQ summary, supplier cards, per-line micro-cells with quality chips.</li>
          <li><b>Decide</b> — single or split supplier; commit with reason + accepted risks.</li>
          <li><b>Audit</b> — immutable SHA-256-hashed log; exportable as PDF/JSON.</li>
          <li><b>Customer quote</b> — Direct/EXW or CNERZY margin; branded PDF + CSV export.</li>
        </ol>
      </div>
    </Shell>
  );
}
